const Align = {
  LEFT: "flex-start",
  RIGHT: "flex-end",
};

export default Align;
